import { render, staticRenderFns } from "./appSidebar.vue?vue&type=template&id=3ee0d152"
import script from "./appSidebar.vue?vue&type=script&lang=js"
export * from "./appSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports